import React from 'react'

export default class ErrorBoundary extends React.Component {
    state = { hasError: false }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo)
    }

    render() {
        if (this.state.hasError)
            return (
                <div style={{ padding: 40, textAlign: 'center' }}>
                    <h2>Something went wrong</h2>
                    <p>Please try reloading the page</p>
                    <button onClick={() => window.location.reload()}>
                        Reload
                    </button>
                </div>
            )

        return this.props.children
    }
}
